export default {
    symbolsKeyValue: "Abc",
    layout: [
        ["q", "w", "e", "r", "t", "z", "u", "i", "o", "p"],
        ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
        ["y", "x", "c", "v", "b", "n", "m"]
    ],
    specialKeysLayout: ["ľ", "š", "č", "ť", "ž", "ý", "á", "í", "é", "ó", "ú", "ä", "ô", "ň"],
    specialKeysLabel: "ľščť"
};
